<div class="ffd-notes-invite-success-container flex flex-col overflow-y-auto sm:overflow-hidden">
  <div class="container mt-3 flex items-center justify-center px-10">
    <img class="h-[48px]" src="assets/images/notes-logo-header.svg" height="48" alt="FFD Notes" />
  </div>

  <div class="flex flex-1 flex-col items-center px-4 py-8 xs:justify-center">
    <div class="flex w-full flex-col gap-6 xs:w-[448px]">
      <div
        class="flex flex-col items-center gap-3 rounded-3xl bg-gradient-to-br from-[#f8fcff] to-[#f0f8ff] px-8 py-6 text-center"
      >
        <svg-icon key="px-96-success" size="3xl" class="self-center"></svg-icon>
        <h1 class="typo-h1 text-text-primary">
          {{ 'ffd_notes_invite_success_title' | translate }}
        </h1>
      </div>

      <div class="flex flex-col gap-3 rounded-3xl border border-text-extra-light bg-background-white p-4">
        <div class="flex flex-col gap-1">
          <h3 class="typo-h4-semibold text-text-primary">{{ 'ffd_notes_invite_success_download_title' | translate }}</h3>
          <p class="typo-h5-light font-extralight text-text-secondary">
            {{ 'ffd_notes_invite_success_download_subtitle' | translate }}
          </p>
        </div>
        <a [href]="iosAppUrl" target="_blank" rel="noopener noreferrer" class="btn-primary-big flex w-full items-center justify-center">
          <svg-icon key="px-24-apple" size="md" class="text-white"></svg-icon>
          {{ 'ffd_notes_invite_success_download_cta' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
